import { render, staticRenderFns } from "./SubjectViewV2.vue?vue&type=template&id=937875ae&"
import script from "./SubjectViewV2.vue?vue&type=script&lang=js&"
export * from "./SubjectViewV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports